import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormControl, FormBuilder,FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { CrewChangeRequestDTO, CrewDetailsDTO } from 'src/app/shared/models/crewChange.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AgentService } from '../../e-booking/shared/services/agent.service';
import { CrewChangeService } from 'src/app/shared/services/crewChange.service';
import { ActualServiceLocation, CCApprovalDecision, CCReviewerDecision, CrewChangeDirection, FormMode, Languages, ServiceLocation, ServiceStatus, ServiceType } from 'src/app/shared/models/enums.model';
import { GenericLookup } from 'src/app/shared/models/general.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { VesselType } from '../../../shared/models/vesselType.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { ResponseObject } from 'src/app/shared/models/response-object.model';

@Component({
  selector: 'app-crew-change-request',
  templateUrl: './crew-change-request.component.html',
  styleUrls: ['./crew-change-request.component.css']
})
export class CrewChangeRequestComponent implements OnInit {
  crewChangeForm: FormGroup;
  showRequest = false;
  crewChangeDTO: CrewChangeRequestDTO = new CrewChangeRequestDTO();
  crewDetailList: CrewDetailsDTO[] = [];
  baseRequestDTO: BaseRequest;
  @ViewChild('CrewChangeTabs',{static: false}) CrewChangeTabs: TabsetComponent;
  @ViewChild('tabOneControls',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwoControls',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('crewChange',{static: false}) crewChangeEle: ElementRef;
  @Input() IsAdminMode: boolean = false;
  @Input() public RequestStatus: number;
  @Output() IMONO: EventEmitter<string> = new EventEmitter();
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  uploadFolder = AppConfig.settings.apiServer.crewChangeUploadsFolder;
  isTabOneValid: boolean = false;
  isTabOneSubmitted: boolean = false;
  formMode: FormMode;
  FormMode: any = FormMode;
  requestId: string;
  nationalities: GenericLookup[];
  directions: SailDirection[] = [];
  vesselTypes: VesselType[] = [];
  currentUser: User = new User();
  changeDirection = CrewChangeDirection;
  displayedLang: any;
  public Languages: any = Languages;
  OtherVesselType = AppConfig.settings.apiServer.OtherVesselType;
  showVesselOther: boolean = false;
  serviceType = ServiceType;
  serviceStatus = ServiceStatus;
  serviceTypeKeys = Object.keys(this.serviceType);
  serviceLocation = ServiceLocation;
  serviceLocationKeys = Object.keys(this.serviceLocation);
  documentProgressE: number[] = [];
  documentProgressD: number[] = [];
  showHR: boolean= false;
  embarkingDetails: boolean = false;
  disEmbarkingDetails: boolean = false;
  isErrorMessage: boolean = false;
  showSubmit: boolean = false;
  formSubmitted: boolean= false;
  responseObj: ResponseObject;
  requestStatus: number;
  isLoaded: boolean = false;
  moreInfomationFromAgent: string = "";
  moreInfomationFromReviewer: any;
  showMoreInfoFromAgent: boolean;
  showMoreInfoFromReviewer: boolean;
  requestCrewDetails: CrewDetailsDTO[] = [];
  formCrewDetails: CrewDetailsDTO[] = [];
  requestCrewDetailsEmbarking: CrewDetailsDTO[] = [];
  requestCrewDetailsDisembarking: CrewDetailsDTO[] = [];
  showEmbarkingURL: boolean = true;
  showDisembarkingURL: boolean = true;
  showRejectionReasonByReviewer: boolean = false;
  showRejectionReasonByApproval: boolean = false;
  rejectionReasonByReviewer: string = "";
  rejectionReasonByApproval: string = "";
  actualDate: Date;
  actualFees: string = "";
  actualLocation: string = "";
  actualService: string = "";
  finalNotes: string = "";
  invoiceURL: string = "";


  constructor(private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private fileService: fileService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private crewChangeService: CrewChangeService,
    private alertService: AlertService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private agentSrv: AgentService, private baseRequestService: BaseRequestService, private router: Router) {

    this.displayedLang = this.globalSrv.getLanguage();

    if (localStorage.getItem('requestId') != undefined) {
      this.requestId = localStorage.getItem('requestId');
      localStorage.removeItem('requestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.requestId = history.state.data.requestId;
    }
    this.currentUser = authSrevice.currentUserValue;
    this.serviceTypeKeys = this.serviceTypeKeys.slice(this.serviceTypeKeys.length / 2);
    this.serviceLocationKeys = this.serviceLocationKeys.slice(this.serviceLocationKeys.length / 2);

    this.documentProgressE.push(0);
    }

  ngOnInit() {
    this.loadLookups();
    this.setFormMode();
    this.buildForm();
  }
  loadLookups(): void {
    this.loadVesselTypes();
    this.loadSailDirections();
    this.loadNationalities();
  }
  loadVesselTypes(): void {
    this.lookupService.GetShipTypes().subscribe(
      data => this.vesselTypes = data.Data.filter(p => p.IsDeleted == false) as VesselType[],
      () => console.log("Something went wrong!!")
    );
  }

  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.directions = data.Data.sort((a, b) => (a.Direction > b.Direction) ? 1 : -1) as SailDirection[],
      () => console.log("Something went wrong!!")
    );
  }
  loadNationalities(): void {
    this.lookupService.GetNationality().subscribe(
      d => this.nationalities = d.Data.filter(p => p.IsDeleted == false),
      () => console.log("Something went wrong!!")
    );
  }
  buildForm() {
    this.crewChangeForm = this.formBuilder.group({
      VesselName: ['', Validators.required],
      IMONO: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern("^[0-9]{7,7}$")]],
      VesselTypeId: [null, Validators.required],
      VesselTypeOther: [''],
      NationalityId: ['', Validators.required],
      SailDirectionId: ['', Validators.required],
      FromPort: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      ToPort: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      TransitDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      ServiceTypeId: [null, Validators.required],
      ServiceLocationId: [null, Validators.required],
      EmbarkingCrewDetails: this.formBuilder.array([]),
      DisembarkingCrewDetails: this.formBuilder.array([]),
      TermsAndConditions: [false, [Validators.requiredTrue]],
    });
  }
  setFormMode(): void {
    if (this.requestId && this.requestId != '') {
      this.globalSrv.isLoaderEnabled = true;
      this.getCrewChangeRequest();
    } else {
      this.formMode = FormMode.Add;
    }
  }
  getCrewChangeRequest() {
    this.crewChangeService.getById(this.requestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.crewChangeDTO = this.responseObj.Data;
          this.requestStatus = this.crewChangeDTO.BaseRequest.StatusId;
          // this.getbaseRequest();
          this.isLoaded = true;
          if (history.state.data && history.state.data.isCompleted) {
            this.crewChangeForm.disable();
            this.formMode = FormMode.Readonly;
            this.IMONO.emit(this.crewChangeDTO.IMONO);
          }
          else if (this.requestStatus == ServiceStatus.CrewChange_MoreInformationRequestedFromAgent && !this.currentUser.IsAdmin) {
            this.showMoreInfoFromAgent = true;
            this.moreInfomationFromAgent = this.responseObj.Data['ReviewerNotes'];
            this.crewChangeForm.enable();
            this.showSubmit = true;
            this.formMode = FormMode.Edit;
          }
          else {
            this.crewChangeForm.disable();
            this.formMode = FormMode.Readonly;
            this.IMONO.emit(this.crewChangeDTO.IMONO);
          }
          if (this.formMode == FormMode.Readonly || this.formMode == FormMode.Edit) {
            this.CrewChangeTabs.tabs[0].disabled = false;
            this.CrewChangeTabs.tabs[1].disabled = false;
          }
          if (this.currentUser.IsAdmin && this.responseObj.Data["ReviewerDecision"] == CCReviewerDecision.MoreInformation) {
            this.showMoreInfoFromAgent = true;
            this.showMoreInfoFromReviewer = false;
            this.moreInfomationFromAgent = this.responseObj.Data['ReviewerNotes'];
          }
          if (this.currentUser.IsAdmin && this.responseObj.Data["ApprovalDecision"] == CCApprovalDecision.CCApproval_MoreInformation) {
            this.showMoreInfoFromAgent = false;
            this.showMoreInfoFromReviewer = true;
            this.moreInfomationFromReviewer =this.responseObj.Data['ApprovalNotes']
          }
          if (this.requestStatus == ServiceStatus.CrewChange_RequestRejected) {
            if (this.responseObj.Data["ReviewerDecision"] == CCReviewerDecision.Reject) {
              this.showRejectionReasonByReviewer = true;
              this.rejectionReasonByReviewer = this.responseObj.Data['ReviewerNotes'];
            } else if (this.responseObj.Data["ApprovalDecision"] == CCApprovalDecision.CCApproval_Reject) {
              this.showRejectionReasonByApproval = true;
              this.rejectionReasonByApproval = this.responseObj.Data['ApprovalNotes'];
            }
          }
          if (this.crewChangeDTO.ActualServiceType == this.serviceType['Crew Embarking']) {
            this.embarkingDetails = true;
            this.disEmbarkingDetails = false;
          } else if (this.crewChangeDTO.ActualServiceType == this.serviceType['Crew Disembarking']) {
            this.embarkingDetails = false;
            this.disEmbarkingDetails = true;
          } else {
            this.embarkingDetails = true;
            this.disEmbarkingDetails = true;
            this.showHR = true;
          }
          if (this.requestStatus == ServiceStatus.CrewChange_CrewChangeDone) {
            this.actualDate = this.responseObj.Data['ActualDate'];
            this.actualFees = this.responseObj.Data['ActualFees'];
            this.actualLocation = ActualServiceLocation[this.responseObj.Data['ActualLocation']];
            this.actualService = ServiceType[this.responseObj.Data['ActualServiceType']];
            this.finalNotes = this.responseObj.Data['FinalNotes'];
            this.invoiceURL = this.uploadUrl + this.uploadFolder + '/' + this.responseObj.Data['InvoiceURL'];
          }
          this.requestCrewDetails = this.responseObj.Data['CrewDetailsDTO'];
          this.requestCrewDetailsEmbarking = this.requestCrewDetails.filter(cd => cd.ChangeDirection == this.changeDirection.Embarking);
          this.requestCrewDetailsDisembarking = this.requestCrewDetails.filter(cd => cd.ChangeDirection == this.changeDirection.Disembarking);
          this.crewChangeForm.setControl('EmbarkingCrewDetails', this.bindCrewDetails(this.requestCrewDetailsEmbarking,"EmbarkingCrewDetails"));
          this.crewChangeForm.setControl('DisembarkingCrewDetails', this.bindCrewDetails(this.requestCrewDetailsDisembarking, "DisembarkingCrewDetails"));
          this.responseObj.Data['CrewDetailsDTO'] = [];
          this.crewChangeForm.patchValue(this.responseObj.Data);
          this.globalSrv.isLoaderEnabled = false;
          if (this.responseObj.Data['TransitDate']) {
            this.crewChangeForm.patchValue({
              TransitDate: new Date(this.responseObj.Data['TransitDate']),
            });
          }
          this.crewChangeForm.patchValue({
            TermsAndConditions: true,
          });
        }
      });
  }
  // getbaseRequest() {
  //   this.baseRequestService.getBaseRequest(this.requestId).subscribe(
  //     d => {
  //       this.baseRequestDTO = d.Data;
  //       this.requestStatus = this.baseRequestDTO.StatusId;
  //     });
  // }

  bindCrewDetails(requestCrewDetails, controlName): any {
    let control = <FormArray>this.crewChangeForm.controls[controlName];
    if (this.requestStatus == ServiceStatus.CrewChange_MoreInformationRequestedFromAgent && !this.currentUser.IsAdmin) {
      requestCrewDetails.forEach((key) => {
        control.push(new FormGroup({
          AttachmentURL: new FormControl(),
          ChangeDirection: new FormControl({ value: key.ChangeDirection, disabled: false }),
          AddedBy: new FormControl({ value: key.AddedBy, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
          Name: new FormControl({ value: key.Name, disabled: false }),
          PassportNumber: new FormControl({ value: key.PassportNumber, disabled: false }),
        }));
      });
    }
    else {
      requestCrewDetails.forEach((key) => {
        control.push(new FormGroup({
          AttachmentURL: new FormControl(),
          ChangeDirection: new FormControl({ value: key.ChangeDirection, disabled: false }),
          AddedBy: new FormControl({ value: key.AddedBy, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
          Name: new FormControl({ value: key.Name, disabled: false }),
          PassportNumber: new FormControl({ value: key.PassportNumber, disabled: false })
        }));
      });
    }
    return control;
  }


  selectTab(tabId: number) {
    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      if (this.ValidateTabOne) {
        this.isTabOneValid = true;
        this.CrewChangeTabs.tabs[tabId].disabled = false;
        this.CrewChangeTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        const invalidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }
    }
    else {
      this.CrewChangeTabs.tabs[tabId].disabled = false;
      this.CrewChangeTabs.tabs[tabId].active = true;
    }
  }

  get f() {
    return this.crewChangeForm.controls;
  }

  get embarkingCrewDetailsLength() {
    return this.crewChangeForm.controls['EmbarkingCrewDetails'].value.length;
  }
  get disembarkingCrewDetailsLength() {
    return this.crewChangeForm.controls['DisembarkingCrewDetails'].value.length;
  }

  get embarkingCrewDetails() {
    return this.crewChangeForm.get('EmbarkingCrewDetails') as FormArray;
  }
  get disembarkingCrewDetails() {
    return this.crewChangeForm.get('DisembarkingCrewDetails') as FormArray;
  }

  get ValidateTabOne() {
    const isValid = !(this.crewChangeForm.controls['VesselName'].invalid
      || this.crewChangeForm.controls['IMONO'].invalid
      || (this.crewChangeForm.controls['VesselTypeId'].invalid
      || this.crewChangeForm.controls['VesselTypeId'].value == 'null')
      || this.crewChangeForm.controls['VesselTypeOther'].invalid
      || this.crewChangeForm.controls['SailDirectionId'].invalid
      || this.crewChangeForm.controls['NationalityId'].invalid
      || this.crewChangeForm.controls['FromPort'].invalid
      || this.crewChangeForm.controls['ToPort'].invalid
      || this.crewChangeForm.controls['TransitDate'].invalid
      || this.crewChangeForm.controls['ServiceTypeId'].invalid
      || this.crewChangeForm.controls['ServiceLocationId'].invalid)
    return isValid;
  }

  get ValidateTabTwo() {
    const isValid = !(this.embarkingCrewDetails.invalid || this.disembarkingCrewDetails.invalid)
    return isValid;
  }

  get validateSubmitButton() {
    if (this.ValidateTabOne) {
      if (this.CrewChangeTabs.tabs[1].disabled == false &&
        this.CrewChangeTabs.tabs[1].active == true) {
        this.showSubmit = true;
      }

    }
    return this.showSubmit;
  }

  vesselTypeChanged(event) {
    let shipType = event.target.value;
    const vesselTypeOther = this.crewChangeForm.get('VesselTypeOther');
    if (shipType === this.OtherVesselType) {
      this.showVesselOther = true;
      vesselTypeOther.setValidators([Validators.required]);
      vesselTypeOther.updateValueAndValidity();
    }
    else {
      this.showVesselOther = false;
      vesselTypeOther.clearValidators();
      vesselTypeOther.updateValueAndValidity();
    }
  }

  addCrewMember(direction: string = null) {
    let control;
    if (direction == 'E') { // EMBARKING
      this.showEmbarkingURL = false;
      control = <FormArray>this.crewChangeForm.controls['EmbarkingCrewDetails'];
      control.push(new FormGroup({
        Name: new FormControl('', Validators.required),
        PassportNumber: new FormControl('', Validators.required),
        AttachmentURL: new FormControl('', FileValidator.validate),
        ChangeDirection: new FormControl(''),
        AddedBy: new FormControl(''),
        Id: new FormControl('')
      }));
      if (this.documentProgressE.length > 1) {
        this.documentProgressE.push(0);
      }
    } else if (direction == 'D') { // DISEMBARKING
      this.showDisembarkingURL = false;
      control = <FormArray>this.crewChangeForm.controls['DisembarkingCrewDetails'];
      control.push(new FormGroup({
        Name: new FormControl('', Validators.required),
        PassportNumber: new FormControl('', Validators.required),
        AttachmentURL: new FormControl('', FileValidator.validate),
        ChangeDirection: new FormControl(''),
        AddedBy: new FormControl(''),
        Id: new FormControl('')
      }));
      if (this.documentProgressD.length > 1) {
        this.documentProgressD.push(0);
      }
    } else {
        control = <FormArray>this.crewChangeForm.controls['EmbarkingCrewDetails'];
        control.push(new FormGroup({
          Name: new FormControl('', Validators.required),
          PassportNumber: new FormControl('', Validators.required),
          AttachmentURL: new FormControl('', FileValidator.validate),
          ChangeDirection: new FormControl(''),
          AddedBy: new FormControl(''),
          Id: new FormControl('')
        }));
        if (this.documentProgressE.length > 1) {
          this.documentProgressE.push(0);
        }
        control = <FormArray>this.crewChangeForm.controls['DisembarkingCrewDetails'];
        control.push(new FormGroup({
          Name: new FormControl('', Validators.required),
          PassportNumber: new FormControl('', Validators.required),
          AttachmentURL: new FormControl('', FileValidator.validate),
          ChangeDirection: new FormControl(''),
          AddedBy: new FormControl(''),
          Id: new FormControl('')
        }));
        if (this.documentProgressD.length > 1) {
          this.documentProgressD.push(0);
        }
    }

    return control;
  }

  deleteCrewMember(direction: string, index: number) {
    if (direction == "E") { //Embarking
      this.embarkingCrewDetails.removeAt(index);
      this.documentProgressE.splice(index, 1); // Remove the corresponding progress value
    } else { // Disembarking
      this.disembarkingCrewDetails.removeAt(index);
      this.documentProgressD.splice(index, 1); // Remove the corresponding progress value
    }

  }

  onFileSelected(event, currFormControl, index, direction) {
    const progressArray = direction == "E" ? this.documentProgressE : this.documentProgressD;
    progressArray[index] = 0;
    let percentDone = 0;
    this.alertService.clear();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let docName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', docName);
      formData.append('FolderName', this.uploadFolder); //New Line


      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            percentDone = Math.round(100 * event.loaded / event.total)
            progressArray[index] = percentDone;
            currFormControl.setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {
            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            currFormControl.setValue(Url);
            currFormControl.setErrors(null);
            if (direction == "E" && this.requestCrewDetailsEmbarking) {
              if (this.requestCrewDetailsEmbarking[index]) {
                this.requestCrewDetailsEmbarking[index].AttachmentURL = Url;
              }
            } else if (direction == "D" && this.requestCrewDetailsDisembarking) {
              if (this.requestCrewDetailsDisembarking[index]) {
                this.requestCrewDetailsDisembarking[index].AttachmentURL = Url;
               }
            }
            currFormControl.updateValueAndValidity();
          }
        }

      );
    }

  }

  OnServiceTypeChange(event) {
    if (event.target.value == this.serviceType['Crew Embarking']) {
      while (this.disembarkingCrewDetails.length !== 0) {
        this.disembarkingCrewDetails.removeAt(0);
      }
      while (this.embarkingCrewDetails.length !== 0) {
        this.embarkingCrewDetails.removeAt(0);
      }
      this.embarkingDetails = true;
      this.disEmbarkingDetails = false;
      this.showHR = false;
      this.addCrewMember('E');
    } else if (event.target.value == this.serviceType['Crew Disembarking']) {
      while (this.disembarkingCrewDetails.length !== 0) {
        this.disembarkingCrewDetails.removeAt(0);
      }
      while (this.embarkingCrewDetails.length !== 0) {
        this.embarkingCrewDetails.removeAt(0);
      }
      this.disEmbarkingDetails = true;
      this.embarkingDetails = false;
      this.showHR = false;
      this.addCrewMember('D');
    } else {
      while (this.disembarkingCrewDetails.length !== 0) {
        this.disembarkingCrewDetails.removeAt(0);
      }
      while (this.embarkingCrewDetails.length !== 0) {
        this.embarkingCrewDetails.removeAt(0);
      }
      this.showHR = true;
      this.embarkingDetails = true;
      this.disEmbarkingDetails = true;
      this.addCrewMember();

    }
  }
  goToTermsAndCond(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.CrewChangeTermsAR, '_blank');
    else
      window.open(AppConfig.settings.apiServer.CrewChangeTermsEN, '_blank');
  }

  getCrewMemberAddedBy(Id) {
    if (this.crewChangeDTO.CrewDetailsDTO) {
      if (this.requestCrewDetails.find(crew => crew.Id == Id)) {
        return this.requestCrewDetails.find(crew => crew.Id == Id).AddedBy;
      }
    }
    return;
  }

  getCrewMemberFinalNotes(Id) {
    if (this.crewChangeDTO.CrewDetailsDTO) {
      if (this.requestCrewDetails.find(crew => crew.Id == Id)) {
        if (this.requestCrewDetails.find(crew => crew.Id == Id).FinalNotes != null) {
          return this.requestCrewDetails.find(crew => crew.Id == Id).FinalNotes;
        } else {
          return '';
        }
      }
    }
    return '';
  }

  onSubmit() {

    const invalidElements = this.crewChangeEle.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      if (!this.isTabOneValid) {
        invalidElements[0].focus();
        this.selectTab(0);
      }
      else if (!this.ValidateTabTwo) {
        invalidElements[0].focus();
        this.selectTab(1);
      }
    }
    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.crewChangeForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.crewChangeForm.get("TransitDate").value) {
      var selectedTransitDate = this.crewChangeForm.get("TransitDate").value.toLocaleString('en-US');
      this.crewChangeForm.controls['TransitDate'].setValue(selectedTransitDate);
    }
    // Combine both FormArrays of Crew Details
    this.embarkingCrewDetails.controls.forEach(control => {
      this.crewDetailList.push(control.value);
    });
    this.disembarkingCrewDetails.controls.forEach(control => {
      this.crewDetailList.push(control.value);
    });
    this.crewChangeDTO = this.crewChangeForm.value;
    this.crewChangeDTO.CrewDetailsDTO = this.crewDetailList;
    this.crewChangeDTO.RequestorId = this.currentUser.UserId;
    this.crewChangeDTO.ActualServiceType = this.crewChangeForm.controls['ServiceTypeId'].value;
    if (this.formMode == FormMode.Add) {
      this.crewChangeService.add(this.crewChangeDTO).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.crewChangeForm.reset();
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;

            }

          });
    }
    if (this.formMode == FormMode.Edit) {
      this.crewChangeDTO.Id = this.requestId;
      this.formCrewDetails = this.crewChangeForm.value.CrewDetailsDTO;
      this.formCrewDetails.forEach((form) => {
        this.requestCrewDetails.forEach((db) => {
          if (form.Id == db.Id && form.AttachmentURL == null) {
            form.AttachmentURL = db.AttachmentURL;
          }
        });
      });
      this.crewChangeService.update(this.crewChangeDTO).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.crewChangeForm.reset();
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
            }

          });
    }
  }


}
